import { useContext, useEffect, useMemo, useState } from "react"
import { AppContext } from "./context"
import { useNavigate, useParams } from "react-router-dom"
import UiButton3 from "./ui_button3"
import EditorImportExport from "./editor_import_export"

const EditorBrandProduct = () => {

    let { id } = useParams()

    let {
        hh,
        ww,
        neonUser,
        marketplaceList,
        getMarketPlace,
        queryAddon, setQueryAddon,
        reloadProductTable, setReloadProductTable,
        brand, setBrand,
        addslashes,
        fetchDataV2
    } = useContext(AppContext)

    let navigate = useNavigate()

    let [load, setLoad] = useState(true)
    let [listLoaded, setListLoaded] = useState(false)
    let [productList, setProductList] = useState([])
    let memoProductList = useMemo(() => productList, [productList])
    let [dataList, setDataList] = useState([])
    let [page, setPage] = useState({
        limit: 100,
        current: 0,
        total: 0,
        custom: false,
    })

    let [table, setTable] = useState(null)
    let [selectedProduct, setSelectedProduct] = useState(null)
    let [selectedKey, setSelectedKey] = useState("")
    let [newValue, setNewValue] = useState("")
    let [rowSuccess, setRowSuccess] = useState(null)
    let [clearField, setClearField] = useState(false)

    let [filtered, setFiltered] = useState(false)
    let [filterCountry, setFilterCountry] = useState("")
    let [filterAsin, setFilterAsin] = useState("")
    let [filterClientTitle, setFilterClientTitle] = useState("")
    let [filterBrand, setFilterBrand] = useState("")
    let [filterCogs, setFilterCogs] = useState("")
    let [filterClientSku, setFilterCLientSku] = useState("")
    let [filterCategory, setFilterCategory] = useState("")
    let [filterSubcategory, setFilterSubcategory] = useState("")
    let [filterAttribute1, setFilterAttribute1] = useState("")
    let [filterAttribute2, setFilterAttribute2] = useState("")
    let [filterExclude, setFilterExclude] = useState("")
    let [filterCaseQty, setFilterCaseQty] = useState("")

    let [editing, setEditing] = useState(false)

    let addQuery = () => {
        let query = ""

        if (filterCountry) {
            if (filterCountry.toLowerCase() == "null") query += ` AND \`Country Code\` IS NULL`
            else query += ` AND LOWER(\`Country Code\`) LIKE LOWER('%${addslashes(filterCountry)}%')`
        }
        if (filterAsin) {
            if (filterAsin.toLowerCase() == "null") query += ` AND \`Child ASIN\` IS NULL`
            else query += ` AND LOWER(\`Child ASIN\`) LIKE LOWER('%${addslashes(filterAsin)}%')`
        }
        if (filterClientTitle) {
            if (filterClientTitle.toLowerCase() == "null") query += ` AND \`Product Name\` IS NULL`
            else query += ` AND LOWER(\`Product Name\`) LIKE LOWER('%${addslashes(filterClientTitle)}%')`
        }
        if (filterBrand) {
            if (filterBrand.toLowerCase() == "null") query += ` AND \`Brand\` IS NULL`
            else query += ` AND LOWER(\`Brand\`) LIKE LOWER('%${addslashes(filterBrand)}%')`
        }
        if (filterCogs) {
            if (filterCogs.toLowerCase() == "null") query += ` AND CAST(\`COGS\` AS STRING) IS NULL`
            else query += ` AND CAST(\`COGS\` AS STRING) LIKE '%${filterCogs}%'\n`
        }
        if (filterClientSku) {
            if (filterClientSku.toLowerCase() == "null") query += ` AND \`Client SKU\` IS NULL`
            else query += ` AND LOWER(\`Client SKU\`) LIKE LOWER('%${addslashes(filterClientSku)}%')\n `
        }
        if (filterCategory) {
            if (filterCategory.toLowerCase() == "null") query += ` AND \`Category\` IS NULL`
            else query += ` AND LOWER(\`Category\`) LIKE LOWER('%${addslashes(filterCategory)}%')\n `
        }
        if (filterSubcategory) {
            if (filterSubcategory.toLowerCase() == "null") query += ` AND \`Subcategory\` IS NULL`
            else query += ` AND LOWER(\`Subcategory\`) LIKE LOWER('%${addslashes(filterSubcategory)}%')\n `
        }
        if (filterAttribute1) {
            if (filterAttribute1.toLowerCase() == "null") query += ` AND \`Attribute 1\` IS NULL`
            else query += ` AND LOWER(\`Attribute 1\`) LIKE LOWER('%${addslashes(filterAttribute1)}%')\n `
        }
        if (filterAttribute2) {
            if (filterAttribute2.toLowerCase() == "null") query += ` AND \`Attribute 2\` IS NULL`
            else query += ` AND LOWER(\`Attribute 2\`) LIKE LOWER('%${addslashes(filterAttribute2)}%')\n `
        }
        if (filterExclude) {
            if (filterExclude.toLowerCase() == "null") query += ` AND \`Exclude From Inv Reports\` IS NULL`
            else query += ` AND LOWER(\`Exclude From Inv Reports\`) = ${filterExclude == 1 ? true : false}`
        }
        if (filterCaseQty) {
            if (filterCaseQty.toLowerCase() == "null") query += ` AND \`Case Qty\` IS NULL`
            else query += ` AND LOWER(\`Case Qty\`) LIKE LOWER('%${addslashes(filterCaseQty)}%')`
        }

        setQueryAddon(query)
        return query
    }

    const getBrandInfo = async () => {
        setLoad(true)

        let query1 = ["admin", "owner"].includes(neonUser.user.role) ?
            "GET_BRAND_INFO_ADMIN" :
            "GET_BRAND_INFO",
            params1 = [id, neonUser.user.agency_id]

        try {
            let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
            if (resp.length == 0) {
                navigate("/brand")
                return
            }
            setBrand(resp[0])
        }
        catch (err) {
            navigate("/brand")
        }
        finally {
            setLoad(false)
        }
    }

    const getTotalProducts = async () => {
        if (!brand.brand_entity_id) return false

        setListLoaded(false)

        try {
            let resp = await fetchDataV2("GET_PRODUCT_COUNT", {
                brand_entity_id: brand.brand_entity_id,
                queryAddon: addQuery()
            }, "/bigquery-sql-v2")
            resp = resp[0].count
            setPage({
                ...page,
                total: Math.ceil(resp / page.limit)
            })
        }
        catch (err) {
            return
        }
        finally {
            setListLoaded(true)
        }
    }

    const getBrandProducts = async () => {
        setListLoaded(false)
        let resp = null

        try {
            resp = await fetchDataV2("GET_BRAND_PRODUCTS", {
                brand_entity_id: brand.brand_entity_id,
                queryAddon: addQuery(),
                limit: page.limit,
                offset: page.limit * page.current
            }, "/bigquery-sql-v2")

            resp = resp.map(x => ({
                ...x,
                "Product ID": x.string_id,
            }))

            setDataList(resp)
            setProductList(resp)
        }
        catch (err) {
            return
        }
        finally {
            setListLoaded(true)
        }
    }

    const goToPage = (num, goTo) => {
        table.clearData();
        num = Number(num)
        if (goTo) {
            setPage({ ...page, current: num, custom: false })
            return
        }
        setPage({ ...page, current: page.current + num })
    }

    const bigQueryEdits = async () => {
        if (!selectedProduct) return
        if (!selectedKey) return
        if (editing) return

        setEditing(true)

        let resp = await fetchDataV2("GET_PRODUCT_EDITS", {
            product_id: selectedProduct.string_id
        }, "/bigquery-sql-v2")

        selectedProduct = { ...selectedProduct, "Product ID": selectedProduct.string_id }

        let jsonData = {
            ...selectedProduct,
            [selectedKey]: clearField ?
                null
                :
                selectedKey == 'Exclude From Inv Reports' ? newValue == 1 ? true : false : newValue
        }

        try {
            if (resp.length == 0) {
                await fetchDataV2("INSERT_PRODUCT_EDIT", {
                    product_id: selectedProduct.string_id,
                    auth0_user_id: neonUser.user.id,
                    json_data: JSON.stringify(jsonData)
                }, "/bigquery-sql-v2")
            }
            else {
                await fetchDataV2("UPDATE_PRODUCT_EDIT", {
                    product_id: selectedProduct.string_id,
                    json_data: JSON.stringify(jsonData)
                }, "/bigquery-sql-v2")
            }

            setNewValue("")
            setSelectedKey("")
            getBrandProducts()
            setSelectedProduct(null)
            setClearField(false)
        }
        catch (err) {
            return
        }
        finally {
            setEditing(false)
        }
    }

    const productEdit = (cell, onRendered, success, cancel, editorParams) => {
        if (editing) return

        let el = null

        if (editorParams.type == "boolean") {
            el = document.createElement("select");
            el.style.width = `100%`;
            el.innerHTML = `
                <option value="">-select-</option>
                <option value="1">True</option>
                <option value="0">False</option>
            `
            el.addEventListener("change", (e) => {
                setNewValue(addslashes(e.target.value))
            });
        }
        else {
            if (editorParams.type == "number") {
                let div = document.createElement("div")
                el = document.createElement("input")
                el.style.width = '100%'
                let span = document.createElement("span")
                span.innerHTML = "$"
                div.appendChild(span)
                div.appendChild(el)
                el.setAttribute("type", "number")
            }
            else {
                el = document.createElement("input")
                el.style.width = '100%'
            }
        }

        let cancelling = (e) => {
            cancel()
            e.preventDefault();
            e.stopPropagation();
            return
        }

        el.addEventListener("keyup", (e) => {
            if (["Escape", "Tab"].includes(e.key)) cancelling(e)
            if (["Enter"].includes(e.key)) {
                setNewValue(addslashes(e.target.value))
                el.blur()
            }
        });

        onRendered(function () {
            el.focus();
        });

        el.value = cell.getData()[cell.getColumn().getField()]

        let elMain = document.createElement("div")
        elMain.setAttribute('class', "d-flex justify-content-between w-100 h-100")

        let option = document.createElement("i")
        option.setAttribute('class', "bi bi-x align-self-center m-0 p-0 h5")
        option.setAttribute('title', "Reset")
        option.addEventListener('click', e => {
            setClearField(true)
        })

        elMain.appendChild(el)
        elMain.appendChild(option)
        return elMain
    }

    const tableEditing = (cell, row) => {
        if (editing) return

        let id = cell.getData()["Product ID"]
        let product = dataList.filter(x => x['string_id'] == id)[0]
        setSelectedProduct(product)
        setSelectedKey(cell.getField())
    }

    useEffect(() => {
        if (reloadProductTable) {
            setReloadProductTable(false)
            setDataList([])
            setProductList([])
            setListLoaded(false)
            getTotalProducts()
            setPage({ ...page, current: 0 })
        }
    }, [reloadProductTable])

    useEffect(() => {
        bigQueryEdits()
    }, [newValue, clearField])

    useEffect(() => {
        setDataList([])
        setProductList([])
        setListLoaded(false)
        getTotalProducts()
        setPage({ ...page, current: 0 })
    }, [filterCaseQty, filterCountry, filterAsin, filterClientTitle, filterBrand, filterCogs, filterClientSku, filterCategory, filterSubcategory, filterAttribute1, filterAttribute2, filterExclude])

    useEffect(() => {
        if (table) table.destroy();

        let tabulator = new window.Tabulator("#tabulator", {
            layout: "fitColumns",
            dataLoader: () => true,
            height: `100%`,
            data: productList,
            columns: [
                { title: "Product ID", field: "Product ID", visible: false },
                {
                    title: "Country", field: "Country Code", headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterCountry
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterCountry(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false
                },
                {
                    title: "Child ASIN", field: "Child ASIN", headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterAsin
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterAsin(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false
                },
                {
                    title: "Product Name", field: "Product Name", maxWidth: '400px', editor: productEdit, headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterClientTitle
                        el.style.width = '100%'
                        el.addEventListener("keyup", e => {
                            if (e.key == "Enter") {
                                setFilterClientTitle(e.target.value)
                                return
                            }
                        })
                        el.addEventListener("blur", e => {
                            e.stopPropagation();
                            e.preventDefault()
                            cancel()
                            return
                        })
                        return el
                    }, headerFilterLiveFilter: false
                },
                {
                    title: "Brand", field: "Brand", editor: productEdit, headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterBrand
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterBrand(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false
                },
                {
                    title: "COGS", field: "COGS", editor: productEdit, headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterCogs
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterCogs(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false, editorParams: { type: "number" }, formatter: "money", formatterParams: {
                        decimal: ".",
                        symbol: "$"
                    }
                },
                {
                    title: `Client SKU`, field: "Client SKU", editor: productEdit, headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterClientSku
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterCLientSku(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false
                },
                {
                    title: "Category", field: "Category", editor: productEdit, headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterCategory
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterCategory(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false
                },
                {
                    title: "Subcategory", field: "Subcategory", editor: productEdit, headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterSubcategory
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterSubcategory(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false
                },
                {
                    title: "Attribute 1", field: "Attribute 1", editor: productEdit, headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterAttribute1
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterAttribute1(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false
                },
                {
                    title: `Attribute 2`, field: "Attribute 2", editor: productEdit, headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterAttribute2
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterAttribute2(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false
                },
                {
                    title: `Exclude From Inv Reports`, field: "Exclude From Inv Reports", editor: productEdit, headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("select")
                        el.innerHTML = `
                            <option value="">-select-</option>
                            <option value="1">True</option>
                            <option value="0">False</option>
                            <option value="null">Null</option>`
                        el.style.width = '100%'
                        el.style.height = '26px'
                        el.value = filterExclude
                        el.addEventListener("change", e => { setFilterExclude(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false, maxWidth: "150px", editorParams: { type: "boolean" }
                },
                {
                    title: "Case Qty", field: "Case Qty", headerFilter: (cell, onRendered, success, cancel) => {
                        let el = document.createElement("input")
                        el.value = filterCaseQty
                        el.style.width = '100%'
                        el.addEventListener("change", e => { setFilterCaseQty(e.target.value) })
                        el.addEventListener("blur", e => { cancel() })
                        return el
                    }, headerFilterLiveFilter: false
                },
            ],
        });

        setTable(tabulator)
        setListLoaded(true)
    }, [memoProductList])

    useEffect(() => {
        if (table) {
            table.on("cellEditing", function (cell, row) {
                tableEditing(cell, row)
            });
        }
    }, [table])

    useEffect(() => {
        if (listLoaded && table) {
            table.clearAlert();
        }
        else if (!listLoaded && table) {
            table.alert("loading")
        }
    }, [listLoaded, table])

    useEffect(() => {
        if (page.total > 0) {
            getBrandProducts()
        }
        else {
            setListLoaded(false)
            setProductList([])
        }
    }, [page])

    useEffect(() => {
        if (brand) getTotalProducts()
    }, [brand])

    useEffect(() => {
        if (id && neonUser) getBrandInfo()
    }, [neonUser])

    useEffect(() => {
        if (marketplaceList.length == 0) getMarketPlace()
    }, [marketplaceList])

    return (
        <div>
            <div className={" d-flex flex-column gap-3 " + (ww < 400 ? "px-1 pt-4" : "p-4")}>
                <div className={`d-flex ${ww < 400 ? "flex-column gap-2 px-1" : `justify-content-between`}`}>
                    <div className="d-flex gap-2" onClick={() => { navigate(-1) }}>
                        <UiButton3 submit={null} />
                        <p className="mb-0 align-self-center fs-4 text-capitalize">Product Data {">"} {brand && brand.brand}</p>
                    </div>
                    <div className={"d-flex gap-2 " + (ww < 450 ? "flex-column w-100" : "")}>
                        <EditorImportExport />
                    </div>
                </div>
                <div style={{ height: `${hh - 210}px`, borderTopLeftRadius: 10, borderTopRightRadius: 10, overflow: "hidden" }}>
                    <div id="tabulator" className="mb-2 poppins"></div>
                </div>
                {page.total > 0 ?
                    <div className="d-flex justify-content-end" style={{ height: 25 }}>
                        <div className="mb-0 poppins d-flex gap-2 text-secondary">
                            {page.current > 0 && <span className="clickable" onClick={() => goToPage(-1)}><i className="bi bi-caret-left-fill"></i>prev</span>}
                            <div className="d-flex gap-2">
                                {!page.custom ?
                                    <>{page.current + 1} <span className="clickable" onClick={() => setPage({ ...page, custom: true })}>...</span></>
                                    :
                                    <div className="d-flex gap-2">
                                        <select value={page.current} onChange={(e) => goToPage(e.target.value, true)}>
                                            {(Array.from({ length: page.total }, (_, i) => i)).map(x => (
                                                <option key={x} value={x}>{x + 1}</option>
                                            ))}
                                        </select>
                                        <span className="clickable" onClick={() => setPage({ ...page, custom: false })}>close</span>
                                    </div>
                                } / {page.total}
                            </div>
                            {page.current + 1 < page.total && <span className="clickable" onClick={() => goToPage(1)}>next<i className="bi bi-caret-right-fill"></i></span>}
                        </div>
                    </div>
                    :
                    null
                }
            </div>
            <style jsx="true">{`
               .clickable {
                    cursor: pointer
               }
               .tabulator .tabulator-header .tabulator-col .tabulator-col-content {
                    background-color: #650260;
                    color: white;
               }
               .tabulator-col-content:hover {
                    background-color: #650260;
                    color: white;
               }
            `}</style>
        </div>
    )
}

export default EditorBrandProduct